import React, { useEffect, useState } from 'react';
import { useAnimatedNumber } from './useAnimatedNumber';
import { money } from './loanMath';

export const AnimatedMoney = ({ value, en, decimals = 2, className = '', testid }) => {
  const shown = useAnimatedNumber(value);
  const [pulse, setPulse] = useState(false);
  useEffect(() => {
    setPulse(true);
    const t = setTimeout(() => setPulse(false), 450);
    return () => clearTimeout(t);
  }, [value]);
  return (
    <span className={`inline-block tabular-nums transition-transform duration-300 ${pulse ? 'scale-[1.04]' : 'scale-100'} ${className}`} data-testid={testid} data-value={value.toFixed(2)}>
      {money(shown, en, decimals)}
    </span>
  );
};
